//copied from VPC
import { Messages } from '../../../../gen-src/Localize';
import { AppUrls } from '../../../app/AppUrls';
import { SearchResultItem } from '../../models/SearchResultTypes';
import { DetailsTooltipStyles } from './DetailsTooltipStyles';
import { EntityLinkProps } from './elements/EntityLink';

export interface ContentTooltipProps {
  content: SearchResultItem;
  urls: AppUrls;
}

export const ContentDescriptionClassNames = [
  'tb-textile',
  'tb-textile-preview-container',
  DetailsTooltipStyles.MetadataValueContentDescription,
].join(' ');

export const getProjectLink = (projectId: string, projectName: string, urls: AppUrls): EntityLinkProps | undefined => {
  return projectId
    ? {
        href: urls.projectUrl(projectId),
        name: projectName,
      }
    : undefined;
};

export const getPersonalSpaceLink = (urls: AppUrls): EntityLinkProps => {
  return {
    name: Messages.personalSpaceGridLabel(),
    href: urls.personalSpaceUrl(),
  };
};

export const TooltipDescriptionTestId = 'tooltip-description-field';
